module.exports = __webpack_public_path__ + "img/total.62405f83.png";